import React from 'react';

type DinacharyaLotusIconProps = {
  className?: string;
};

const PETAL_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];

const DinacharyaLotusIcon: React.FC<DinacharyaLotusIconProps> = ({ className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    {PETAL_ANGLES.map((angle) => (
      <path
        key={angle}
        d="M 12 9.5 Q 9.5 6 12 2.5 Q 14.5 6 12 9.5 Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        transform={`rotate(${angle} 12 12)`}
      />
    ))}
    <circle cx="12" cy="12" r="1.45" fill="currentColor" />
  </svg>
);

export default DinacharyaLotusIcon;
